import { jsx as _jsx } from "react/jsx-runtime";
import { classNameFactory } from "@src/utils/dom";
import "./container.scss";
const cn = classNameFactory("container");
export const Container = props => {
    const { children, className = "", ...rest } = props;
    return (_jsx("div", { className: `${cn("")} ${className}`.trim(), ...rest, children: children }));
};
